var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBe = function SvgBe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h213.335v479.997H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd90c",
    d: "M213.335 0H426.67v479.997H213.335z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f31830",
    d: "M426.67 0h213.335v479.997H426.67z"
  }))));
};
export default __webpack_public_path__ + "assets/0dec981fbfb6d9a4b25291c7d32737a6.svg";
export { SvgBe as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/be.svg